import { useEffect } from 'react';
import type { PinType } from '../services/analytics';
import type { CommentPinType } from '../types';
import CommentsSection from './CommentsSection';

interface CommentsModalProps {
  pinType: PinType;
  pinTypeApi: CommentPinType;
  pinId: string;
  onClose: () => void;
}

const PIN_TYPE_LABEL: Record<PinType, string> = {
  spot: 'parking spot',
  seeker: 'seeker pin',
  rent: 'price data pin',
};

export default function CommentsModal({ pinType, pinTypeApi, pinId, onClose }: CommentsModalProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="fixed inset-0 bg-black/50 z-[160] flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md max-h-[85vh] flex flex-col overflow-hidden">
        <div className="flex-shrink-0 p-4 border-b flex items-center justify-between bg-gray-50 rounded-t-2xl">
          <h2 className="font-semibold text-gray-900">
            Comments on this {PIN_TYPE_LABEL[pinType]}
          </h2>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="text-gray-500 hover:text-gray-700 text-xl leading-none"
          >
            &times;
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-5 min-h-0">
          <CommentsSection pinType={pinType} pinTypeApi={pinTypeApi} pinId={pinId} />
        </div>
      </div>
    </div>
  );
}
